module.exports = __webpack_public_path__ + "assets/img/twitter.9937c61c.webp";